import { formatLocaleCurrencyWithMillionLabel } from "@/utils/formatUtils";
import type { CoverageLimitBase } from "./types";

export const formatCoverageLimit = (coverageLimit?: CoverageLimitBase) => {
  return coverageLimit
    ? formatLocaleCurrencyWithMillionLabel(coverageLimit.health) +
        " / " +
        formatLocaleCurrencyWithMillionLabel(coverageLimit.property)
    : undefined;
};
